import type { LpProductListCols } from '@wconcept/wconcept-common/utils/lpProductListCols';

type BrandCategoryDepth = 1 | 2 | 3;

type BrandCategoryTabClickInput = {
  readonly depth: BrandCategoryDepth;
  readonly name: string;
  readonly displayIndex: number;
};

type BrandButtonClickParams = {
  readonly area: string;
  readonly text: string;
  readonly listNo?: number;
};

const BRAND_CATEGORY_TAB_AREAS: Record<BrandCategoryDepth, string> = {
  1: 'brand_category1_tab',
  2: 'brand_category2_tab',
  3: 'brand_category3_tab',
};

export const getBrandCategoryTabClickParams = ({
  depth,
  name,
  displayIndex,
}: BrandCategoryTabClickInput): BrandButtonClickParams => ({
  area: BRAND_CATEGORY_TAB_AREAS[depth],
  text: name,
  listNo: displayIndex + 1,
});

export const getBrandItemUiButtonClickParams = (
  currentCols: LpProductListCols
): BrandButtonClickParams => ({
  area: 'brand_itemui_button',
  text: `${currentCols}열`,
});

export const getBrandPageItemListParam = (
  currentCols: LpProductListCols
): string => `${currentCols}열`;
